<template src="./index.html"></template>
<script>
import { getdata } from './data.js';
import com from '../../../../../comMapping.js';
import Historical from '../Historical/index.vue'
export default {
	name: '',
	components: {
		Historical
	},
	props: {
		codedetailDiag: {
			type: Boolean,
			default: false
		},
		id: ''
	},
	watch: {
		codedetailDiag: function(indexVal, oldVal) {
			if (indexVal) {
				this.initialization();
			}
		}
	},
	data: function() {
		return {
			dataList:{},
			HistoricalDiag:false,
			headData: getdata().headData,
			pagination: getdata().pagination, //分页数据
			tableData: [], //表格内容数据
			tablekey: 0,
			//排序字段
			order: '',
			//排序顺序
			sort: '',
			//筛选字段
			param: {
				keyWord: '',
				id: '',
				docStatus: com.lqdjzt.map(item => item.code),
				invoiceType: com.lqfplx.map(item => item.code)
			}
		};
	},
	created() {},
	methods: {
		// 历史赋码记录页面
		details(e){
			this.HistoricalDiag = true
			this.dataList = e
			this.$nextTick(()=>{
				this.$refs.Historical.page()
			})
		},
		closediags(){
			this.HistoricalDiag = false
		},
		//初始化
		initialization() {
			let params = {};
			params.limit = this.pagination.pageSize;
			params.page = this.pagination.pageNum;
			params.sort = this.sort;
			params.order = this.order;
			this.param.docStatus.push('');
			this.param.invoiceType.push('');
			params.param = this.param;
			params.param.id = this.id;
			this.$https.fetchPost('/natural/codeAssignment/findCodeAssignmentDetail', params).then(res => {
				this.tableData = res.data.data;
				this.pagination.total = res.data.count;
			});
		},
		//表格体
		forsearch() {
			this.pagination.pageNum = 1;
			this.tablekey++;
			this.initialization();
		},
		//表格体 排序
		sortchange(e) {
			if (e.order != null) {
				this.sort = e.order == 'ascending' ? 'ASC' : 'DESC';
				this.order = e.prop;
			} else {
				this.sort = '';
				this.order = '';
			}
			this.initialization();
		}, //筛选数组
		forSearchScreeningBox(obj) {
			this.param.docStatus = obj.docStatus;
			this.param.invoiceType = obj.invoiceType;
			this.initialization();
		},

		currentChange(e) {
			this.pagination.pageNum = e;
			this.initialization();
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.initialization();
		},
		closediag() {
			this.$emit('closediag', false);
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
